import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editcustomfrom',
  templateUrl: './editcustomfrom.component.html',
  styleUrls: ['./editcustomfrom.component.css']
})
export class EditcustomfromComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  searchValue(e:any){
    
  }
}
